import React, { useCallback, useEffect, useState, useContext } from 'react';
import Card from 'components/inputs/Card';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import CustomerProfile from './CustomerProfile';
import DropDown from 'components/inputs/DropDown';
import { BsThreeDots } from 'react-icons/bs';
import {
  FETCH_CUSTOMER_PROFILE,
  GET_CUSTOMER,
  UPDATE_CUSTOMER,
  WALLET_TRANSACTION,
  SYNC_WALLET,
  FETCH_ROLES,
  RESET_OTP_LIMIT,
  UPDATE_CUSTOMER_VEHICLE,
  RECONCILE_WALLET_BALANCE,
} from 'actions/customer';
import { GET_TENANT } from 'actions/tenant';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';
import CustomerBooking from './CustomerBooking';
import CustomerTransaction from './CustomerTransaction';
import PreloadedTransaction from './PreloadedTransaction';
import CustomerFaultyTransaction from './CustomerFaultyTransaction';
import { AiOutlineCar } from 'react-icons/ai';
import { CREATE_STATUS_CODE, GET_CUSTOMERS, MANAGE_CUSTOMERS, UPDATE_STATUS_CODE } from 'components/common/constant';
import { Modal } from 'react-bootstrap';
import { MdClose, MdRefresh } from 'react-icons/md';
import { Form, Formik } from 'formik';
import { Col, Row } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import * as Yup from 'yup';
import Select from 'components/inputs/Select';
import Button from 'components/inputs/Button';
import { toast } from 'react-toastify';
import PhoneNumberInput from 'components/inputs/PhoneNumberInput';
import RfidDetailsModal from './RfidDetailsModal';
// import { FETCH_ROLE } from 'actions/role';
// import { CHANGE_ROLE } from 'actions/user';
// import { TENANT_ADMIN, ADMIN } from 'components/common/constant';
import ChargeCoinTransaction from './ChargeCoinTransaction';
import PaymentStatus from './PaymentStatus';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import ToggleSwitch from 'components/inputs/ToggleSwitch';
import { UPDATE_VEHICLE } from 'actions/vehicle';
import Footer from 'components/general/Footer';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { UPDATE_USER } from 'actions/user';
import ScheduleBookingForm from './BookingForm';
import CheckBox from 'components/inputs/CheckBox';
import { useLocation } from 'react-router-dom';
import { parsePhoneNumber } from 'react-phone-number-input';
import moment from 'moment';


const CustomerDetail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const { customerId } = useParams();
  const { navigateTo, isAllowed } = useContext(NavContext);
  const [currentTab, setCurrentTab] = useState('bookings');
  const allRoles = useSelector((state) => state.customer.role);
  const profileData = useSelector((state) => state.profile.userProfile);
  const [showWalletForm, setShowWalletForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showRoleForm, setShowRoleForm] = useState(false);
  const [showEditVehicleForm, setShowEditVehicleForm] = useState(false);
  const [vehicleId, setVehicleId] = useState('');
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [showModal, setShowModal] = useState('');
  const [showVehicleDetailsModal, setShowVehicleDetailsModal] = useState(false);
  const [showUnmapConfirm, setShowUnmapConfirm] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const isLoader = useSelector((state) => state.profile.isLoading);
  const customerProfileList = useSelector((state) => state.customerProfile.customerProfile);
  const isLoading = useSelector((state) => state.customerProfile.isLoading);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);
  const currentUserName = _.get(profileData, 'name', '');
  const isDeleted = _.get(customerProfileList, 'deleted');
  const currentVehicle = vehicleId && customerProfileList?.vehicles.filter((item) => item.id === vehicleId);
  const tenantDetail = useSelector((state) => state.tenant.tenantDetail);
  const [contactNumber, setContactNumber] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const isReconcilingWallet = useSelector((state) => state.customerProfile.isReconciling);
  const [oldPhoneNumber, setOldPhoneNumber] = useState('');
  const getPhoneNumber = _.get(parsePhoneNumber(contactNumber), 'nationalNumber', '');
  const getCustomerProfile = useCallback((id) => {
    dispatch({ type: FETCH_CUSTOMER_PROFILE.REQUEST, payload: id });
  }, []);

  const isAdminRoute = location.pathname.includes('/customerProfileAdmin');

  const getAllRoles = useCallback((data) => {
    dispatch({ type: FETCH_ROLES.REQUEST, payload: data });
  }, []);

  // const editUserRole = useCallback(
  //   (role, userId) => {
  //     const userRole = {
  //       id: userId,
  //       role: role,
  //     };
  //     dispatch({ type: CHANGE_ROLE, payload: userRole });
  //   },
  //   [allRoles]
  // );

  useEffect(() => {
    getAllRoles();
  }, [customerId]);

  useEffect(() => {
    if (customerProfileList && customerProfileList.tenant) {
      const tId = typeof customerProfileList.tenant === 'object' ? (customerProfileList.tenant._id || customerProfileList.tenant.id) : customerProfileList.tenant;
      if (tId) {
        dispatch({ type: GET_TENANT.REQUEST, payload: tId });
      }
    }
  }, [customerProfileList?.tenant, dispatch]);

  useEffect(() => {
    if (customerProfileList) {

      setOldPhoneNumber(_.get(customerProfileList, 'phone', ''));
    }
  }, [customerProfileList]);

  const updateCustomer = useCallback(
    (data) => {
      const customerData = {
        ...data,
        id: customerId,
      };
      dispatch({
        type: UPDATE_USER.REQUEST,
        payload: customerData,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            toast.success('Customer updated successfully');
            setTimeout(() => {
              getCustomerProfile(customerId);
              setShowEditForm(false);
            }, 500);
          }
        },
      });
    },
    [customerId, getCustomerProfile]
  );

  const suspendCustomer = useCallback(
    (data) => {
      const customerData = {
        ...data,
        id: customerId,
      };
      dispatch({
        type: UPDATE_CUSTOMER.REQUEST,
        payload: customerData,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            // toast.success('Customer updated successfully');
            navigateTo(isAdminRoute ? `/customerProfileAdmin/${customerId}` : `/customerProfile/${customerId}`);
          }
        },
      });
    },
    [customerId]
  );

  const autoChargeCustomer = useCallback(
    (data) => {
      dispatch({
        type: UPDATE_VEHICLE.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            setTimeout(() => {
              getCustomerProfile(customerId);
            }, 500);
          }
        },
      });
    },
    [customerId, getCustomerProfile]
  );

  const getCustomerDetail = useCallback((id) => {
    dispatch({ type: GET_CUSTOMER.REQUEST, payload: id });
  });

  const walletTransaction = useCallback(
    (data = {}) => {
      dispatch({
        type: WALLET_TRANSACTION.REQUEST,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === CREATE_STATUS_CODE) {
              toast.success('Transaction in wallet successfully');
              setShowWalletForm(false);

              // Reload the customer profile data after wallet transaction is successful
              getCustomerProfile(customerId);

              // Navigate to the customer's profile page if needed
              navigateTo(isAdminRoute ? `/customerProfileAdmin/${customerId}` : `/customerProfile/${customerId}`);
            }
          }
        },
      });
    },
    [customerId, getCustomerProfile, navigateTo]
  );

  const editVehicleDetail = useCallback(
    (data) => {
      dispatch({
        type: UPDATE_CUSTOMER_VEHICLE.REQUEST,
        payload: { ...data },
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            toast.success('EVCC ID updated successfully');
            setTimeout(() => {
              getCustomerProfile(customerId);
              setShowEditVehicleForm(false);
            }, 1000);
          }
        },
      });
    },
    [customerId, getCustomerProfile]
  );

  const handleUnmap = () => {
    editVehicleDetail({
      evcc_id: null,
      evcc_id_2: null,
      is_autocharge_enabled: false,
      id: vehicleId,
    });
    setShowUnmapConfirm(false);
    setShowEditVehicleForm(false);
  };

  const syncWallet = useCallback(
    (data) => {
      dispatch({
        type: SYNC_WALLET.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            toast.success('Wallet Synced Successfully');
            setTimeout(() => {
              setCurrentTab('transactions');
            }, 1000);
            navigateTo(isAdminRoute ? `/customerProfileAdmin/${customerId}` : `/customerProfile/${customerId}`);
          }
        },
      });
    },
    [customerId]
  );

  const resetOTPLimit = useCallback(
    (data) => {
      dispatch({
        type: RESET_OTP_LIMIT.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            toast.success('Reset max OTP limit successfully');
            setTimeout(() => {
              getCustomerProfile(customerId);
            }, 1000);
          }
        },
      });
    },
    [customerId, getCustomerProfile]
  );

  const handleReconcileWallet = useCallback((isAutoClick = false) => {
    dispatch({
      type: RECONCILE_WALLET_BALANCE.REQUEST,
      payload: customerId,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          if (isAutoClick !== true) {
            toast.success('Wallet balance reconciled successfully');
          }
          getCustomerProfile(customerId);
        }
      },
    });
  }, [customerId, getCustomerProfile]);

  useEffect(() => {
    getCustomerProfile(customerId);
  }, [customerId, getCustomerProfile]);

  const setTab = (e, tab) => {
    e.preventDefault();
    setCurrentTab(tab);
    if (tab === 'transactions') {
      const customerRole = _.get(customerProfileList, 'role', '');
      if (customerRole !== 'fleet_member' && customerRole !== 'fleet_owner') {
        handleReconcileWallet(true);
      }
    }
  };

  const handleClose = () => {
    setShowWalletForm(false);
    setShowEditForm(false);
    setShowRoleForm(false);
    setShowModal(false);
    setShowBookingForm(false);
    setShowEditVehicleForm(false);
  };

  const getCustomerPermissions =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_CUSTOMERS),
      (data) => data.name
    );

  const manageCustomerPermissions =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_CUSTOMERS),
      (data) => data.name
    );

  const WalletTransactionSchema = Yup.object().shape({
    message: Yup.string().required(t('customerDetail.message')),
    type: Yup.string().required(t('customerDetail.type')),
    amount: Yup.number().required(t('customerDetail.amount')),
  });

  const CustomerSchema = Yup.object().shape({
    // first_name: Yup.string().required(t('customerDetail.firstName')).max(100, t('customerDetail.maxlimit')),
    // last_name: Yup.string().required(t('customerDetail.lastName')).max(100, t('customerDetail.maxlimit')),
    username: Yup.string().required(t('customerForm.username')).min(8, t('customerForm.minLength')),
    // password: Yup.string().required(t('customerForm.password')),
  });

  const VehicleSchema = Yup.object().shape({
    evcc_id: Yup.string().required(t('customerDetail.validationEvcc')),
  });

  return (
    <React.Fragment>
      <LayoutContainer className="layout-container-main-page">
        <AdminHeader title={t('header.customerProfile')} backTo={isAdminRoute ? '/customers/admin' : '/customers'} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="customerDetail-page__main">
              <Card>
                <div className="page--info">
                  {/* ── Left: Avatar + Identity ── */}
                  <div className="page--info--inner">
                    <div className="page-avatar">
                      {isLoader ? (
                        <Skeleton height={60} width={60} circle />
                      ) : (
                        <div className="customer-avatar-initials">
                          {_.isEmpty(_.get(customerProfileList, 'first_name')) && _.isEmpty(_.get(customerProfileList, 'last_name'))
                            ? 'GU'
                            : `${(_.get(customerProfileList, 'first_name', '?')[0] || '').toUpperCase()}${(_.get(customerProfileList, 'last_name', '')[0] || '').toUpperCase()}`}
                        </div>
                      )}
                    </div>

                    <div className="customer-content">
                      {/* Name */}
                      <div className="customer-name-row">
                        <span className="customer-name">
                          {isLoading ? (
                            <Skeleton height={24} width={160} />
                          ) : _.isEmpty(_.get(customerProfileList, 'first_name')) && _.isEmpty(_.get(customerProfileList, 'last_name')) ? (
                            'Guest User'
                          ) : !_.isEmpty(_.get(customerProfileList, 'first_name')) && _.isEmpty(_.get(customerProfileList, 'last_name')) ? (
                            _.get(customerProfileList, 'first_name')
                          ) : (
                            `${_.get(customerProfileList, 'first_name')} ${_.get(customerProfileList, 'last_name')}`
                          )}
                        </span>
                      </div>

                      {/* Phone + Tenant */}
                      {_.get(customerProfileList, 'phone') && (
                        <div className="customer-meta-row">
                          <span className="customer-info">
                            {isLoading ? <Skeleton height={14} width={130} /> : `${_.get(customerProfileList, 'country_code') ? '+' + _.get(customerProfileList, 'country_code') + '\u00a0' : ''}${_.get(customerProfileList, 'phone')}`}
                          </span>
                          {tenantDetail?.name && !isLoading && (
                            <>
                              <span className="meta-separator">·</span>
                              <span className="customer-tenant">{tenantDetail.name}</span>
                            </>
                          )}
                        </div>
                      )}

                      {/* Role badge */}
                      {(_.get(customerProfileList, 'role') === 'fleet_member' || _.get(customerProfileList, 'role') === 'fleet_owner') && (
                        <div className="customer-role">
                          <span className="role-badge">
                            {isLoading ? <Skeleton height={18} width={90} /> : _.startCase(_.get(customerProfileList, 'role', ''))}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ── Right: Actions ── */}
                  {(isAdminRoute ||
                    !_.isEmpty(manageCustomerPermissions) ||
                    (!_.isEmpty(getCustomerPermissions) && !_.isEmpty(manageCustomerPermissions))) && (
                      <div className="customerDetail-dropdown_btn">
                        <Button
                          className="update-wallet-btn"
                          onClick={handleReconcileWallet}
                          disabled={isReconcilingWallet}
                        >
                          <MdRefresh className={`refresh-icon${isReconcilingWallet ? ' spinning' : ''}`} />
                          {isReconcilingWallet ? 'Updating…' : 'Update Transactions'}
                        </Button>

                        {!isDeleted === true && (
                          <DropDown
                            trigger={
                              <div className="dropdown-icon">
                                <BsThreeDots />
                              </div>
                            }
                            popupClass="bottom-left"
                          >
                            <ul>
                              {isLoading ? (
                                <Skeleton height={20} width={100} />
                              ) : !isAdminRoute && _.get(customerProfileList, 'isActive') ? (
                                <li className="item" onClick={() => suspendCustomer({ isActive: false })}>
                                  {t('customerDetail.suspend')}
                                </li>
                              ) : (
                                !isAdminRoute && (
                                  <li className="item" onClick={() => suspendCustomer({ isActive: true })}>
                                    {t('customerDetail.active')}
                                  </li>
                                )
                              )}
                              {isAllowed('scheduleBookingCustomerManagement') && (
                                <li className="item" onClick={() => setShowBookingForm(true)}>
                                  {t('customerDetail.scheduleBooking')}
                                </li>
                              )}
                              {!isAdminRoute && (
                                <li className="item" onClick={() => setShowEditForm(true)}>
                                  {t('customerDetail.edit')}
                                </li>
                              )}
                              {(isAdminRoute || isAllowed('syncWalletBalanceCustomerManagement')) && (
                                <li className="item" onClick={() => syncWallet({ id: customerId })}>
                                  {t('customerDetail.syncWallet')}
                                </li>
                              )}
                              {(isAdminRoute || isAllowed('updateWalletBalanceCustomerManagement')) && (
                                <li className="item" onClick={() => setShowWalletForm(true)}>
                                  {t('customerDetail.updateWallet')}
                                </li>
                              )}
                              {isAllowed('assignRFIDCustomerManagement') && (
                                <li
                                  className="item"
                                  onClick={() => { setShowModal(true); getCustomerDetail(customerId); }}
                                >
                                  {_.isEmpty(_.get(customerProfileList, 'rfid')) ? t('customerDetail.assignRFID') : t('customerDetail.manageRFID')}
                                </li>
                              )}
                              {isAllowed('changeRoleCustomerManagement') && (
                                <li className="item" onClick={() => setShowRoleForm(true)}>
                                  {t('customerDetail.changeRole')}
                                </li>
                              )}
                              <li className="item" onClick={() => resetOTPLimit({ number: _.get(customerProfileList, 'phone') })}>
                                {t('customerDetail.resetOTP')}
                              </li>
                            </ul>
                          </DropDown>
                        )}
                      </div>
                    )}
                </div>
                <div>
                  <div className="tab-block">
                    <div className="tab-nav-block">
                      <a
                        href="#"
                        className={`tab-nav__item ${currentTab === 'profile' ? 'active' : ''}`}
                        onClick={(e) => setTab(e, 'profile')}
                        data-content="tab-profile"
                      >
                        {isLoading ? <Skeleton height="20" width="100" /> : t('customerDetail.tabProfile')}
                      </a>
                      {(isAdminRoute || isAllowed('viewBookingsCustomerManagement')) && (
                        <a
                          href="#"
                          className={`tab-nav__item ${currentTab === 'bookings' ? 'active' : ''}`}
                          onClick={(e) => setTab(e, 'bookings')}
                          data-content="tab-bookings"
                        >
                          {isLoading ? <Skeleton height="20" width="100" /> : t('customerDetail.tabBookings')}
                        </a>
                      )}
                      {(isAdminRoute || isAllowed('viewTransactionsCustomerManagement')) && (
                        <a
                          href="#"
                          className={`tab-nav__item ${currentTab === 'transactions' ? 'active' : ''}`}
                          onClick={(e) => setTab(e, 'transactions')}
                          data-content="tab-transactions"
                        >
                          {isLoading ? <Skeleton height="20" width="100" /> : t('customerDetail.tabTransactions')}
                        </a>
                      )}
                      {isAllowed('viewTransactionsCustomerManagement') && (
                        <a
                          href="#"
                          className={`tab-nav__item ${currentTab === 'Faultytransactions' ? 'active' : ''}`}
                          onClick={(e) => setTab(e, 'Faultytransactions')}
                          data-content="tab-transactions"
                        >
                          {isLoading ? <Skeleton height="20" width="100" /> : t('customerDetail.faultyTransaction')}
                        </a>
                      )}
                      {/* CDB-1085 - shown for any customer who ever received pre-loaded
                          credit, so the record stays reachable after a campaign ends. */}
                      {_.get(customerProfileList, 'has_preloaded_history') && (
                        <a
                          href="#"
                          className={`tab-nav__item ${currentTab === 'preloadedTransactions' ? 'active' : ''}`}
                          onClick={(e) => setTab(e, 'preloadedTransactions')}
                          data-content="tab-preloadedTransactions"
                        >
                          {isLoading ? <Skeleton height="20" width="100" /> : 'PreLoaded Transaction'}
                        </a>
                      )}
                      {isAllowed('viewChargeCoinTransactions') && (
                        <a
                          href="#"
                          className={`tab-nav__item ${currentTab === 'chargeCoinTransactions' ? 'active' : ''}`}
                          onClick={(e) => setTab(e, 'chargeCoinTransactions')}
                          data-content="tab-chargeCoinTransactions"
                        >
                          {isLoading ? <Skeleton height="20" width="100" /> : t('customerDetail.tabChargecoin')}
                        </a>
                      )}
                      {(isAdminRoute || isAllowed('viewTransactionsCustomerManagement')) && (
                        <a
                          href="#"
                          className={`tab-nav__item ${currentTab === 'paymentStatus' ? 'active' : ''}`}
                          onClick={(e) => setTab(e, 'paymentStatus')}
                          data-content="tab-paymentStatus"
                        >
                          {isLoading ? <Skeleton height="20" width="100" /> : t('customerDetail.tabPaymentStatus')}
                        </a>
                      )}
                    </div>
                    {currentTab === 'profile' && (
                      <div className="tab-content-block">
                        <div className="tab-content__item active" id="charger-details-tab">
                          {currentTab === 'profile' && <CustomerProfile />}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Card>

              {currentTab === 'profile' && (
                <Card className="customerDetail-table">
                  <div className="customerDetail-table-heading">
                    {isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.vehicleDetails')}
                  </div>
                  <div className="customerDetail-list-table">
                    <div className="table-responsive">
                      <table className="record-list-table">
                        <thead>
                          <tr>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.srNo')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.vehicleName')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('Registration & VIN')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.sessions')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('customerDetail.evccId')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('AutoCharge')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height="20" width="100" /> : t('Actions')}</span>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {_.isEmpty(_.get(customerProfileList, 'vehicles')) ? (
                            <tr>
                              <td colSpan={7} className="border-0">
                                <div className="empty-data-block">{t('customerDetail.noData')}</div>
                              </td>
                            </tr>
                          ) : (
                            _.map(_.get(customerProfileList, 'vehicles'), (vehicle, index) => {
                              return (
                                <tr key={`vehicle-data-item-${index}`}>
                                  <td>{isLoader ? <Skeleton height={20} width={100} /> : index + 1}</td>
                                  <td>
                                    {isLoader ? (
                                      <div className="d-flex align-items-center gap-3">
                                        <Skeleton height={60} width={60} style={{ borderRadius: '12px' }} />
                                        <Skeleton height={20} width={100} />
                                      </div>
                                    ) : (
                                      <div className="d-flex align-items-center gap-3">
                                        <div className="vehicle-image-wrapper" style={{
                                          width: '64px',
                                          height: '64px',
                                          borderRadius: '12px',
                                          background: vehicle.picture || vehicle.evcatalog?.picture ? 'transparent' : 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          boxShadow: vehicle.picture || vehicle.evcatalog?.picture ? 'none' : '0 4px 15px rgba(0,0,0,0.2)',
                                          overflow: 'hidden',
                                          border: vehicle.picture || vehicle.evcatalog?.picture ? 'none' : '1px solid rgba(255,255,255,0.1)',
                                          position: 'relative',
                                          flexShrink: 0
                                        }}>
                                          {vehicle.picture || vehicle.evcatalog?.picture ? (
                                            <img 
                                              src={vehicle.picture || vehicle.evcatalog?.picture} 
                                              alt="Vehicle" 
                                              style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
                                            />
                                          ) : (
                                            <AiOutlineCar size={32} color="#00f2fe" style={{ filter: 'drop-shadow(0 2px 5px rgba(0,242,254,0.4))' }} />
                                          )}
                                          {_.get(vehicle, 'is_default') === true && (
                                            <span style={{
                                              position: 'absolute',
                                              bottom: '0',
                                              left: '0',
                                              right: '0',
                                              backgroundColor: 'rgba(15, 155, 114, 0.95)',
                                              color: '#fff',
                                              fontSize: '8px',
                                              fontWeight: '700',
                                              textAlign: 'center',
                                              padding: '2px 0',
                                              textTransform: 'uppercase',
                                              letterSpacing: '0.5px',
                                              lineHeight: '1.1'
                                            }}>
                                              Default
                                            </span>
                                          )}
                                        </div>
                                        <div className="d-flex flex-column">
                                          <span className="fw-bold" style={{ color: '#fff', fontSize: '15px' }}>
                                            {_.get(vehicle, 'make', '')} {_.get(vehicle, 'model', '')}
                                          </span>
                                          {_.get(vehicle, 'year') && (
                                            <span style={{ fontSize: '12px', color: '#8a99a8', marginTop: '2px' }}>
                                              Year: {_.get(vehicle, 'year')}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={20} width={100} />
                                    ) : (
                                      <div className="d-flex flex-column">
                                        <div style={{ fontWeight: '500', color: '#fff' }}>
                                          RTO: {_.get(vehicle, 'rto_no') || _.get(vehicle, 'rto_num') || '-'}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#8a99a8', marginTop: '2px' }}>
                                          VIN: {_.get(vehicle, 'vin_num') || '-'}
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                  <td>{isLoader ? <Skeleton height={20} width={100} /> : _.get(vehicle, 'session_count', '-')}</td>
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={20} width={100} />
                                    ) : (
                                      <div style={{ fontSize: '13px', color: '#fff' }}>
                                        {!_.isEmpty(vehicle.evcc_id) || !_.isEmpty(vehicle.evcc_id_2) ? (
                                          <>
                                            {vehicle.evcc_id && <div>Gun 1: <code style={{ color: '#00f2fe' }}>{vehicle.evcc_id}</code></div>}
                                            {vehicle.evcc_id_2 && <div style={{ marginTop: '2px' }}>Gun 2: <code style={{ color: '#00f2fe' }}>{vehicle.evcc_id_2}</code></div>}
                                          </>
                                        ) : (
                                          '-'
                                        )}
                                      </div>
                                    )}
                                  </td>
                                  <td title="Enable/Disable AutoCharge">
                                    {isLoader ? (
                                      <Skeleton height={20} width={100} />
                                    ) : (
                                      <ToggleSwitch
                                        title="Enable/Disable AutoCharge"
                                        checked={_.get(vehicle, 'is_autocharge_enabled')}
                                        onChange={(e) => {
                                          const isCheck = e.target.checked;
                                          const id = _.get(vehicle, 'id');
                                          const customerData = _.omit(vehicle, [
                                            'is_default',
                                            'year',
                                            'unit_consumed',
                                            'no_of_session',
                                            'anpr_enabled',
                                            'evcatalog',
                                            'evmasterdata',
                                            'temp_evcc_id',
                                            'temp_evcc_id_date',
                                          ]);
                                          if (isCheck) {
                                            autoChargeCustomer({ ...customerData, is_autocharge_enabled: true, id });
                                          } else {
                                            autoChargeCustomer({ ...customerData, is_autocharge_enabled: false, id });
                                          }
                                        }}
                                        disabled={isDeleted || (_.isEmpty(_.get(vehicle, 'evcc_id')) && _.isEmpty(_.get(vehicle, 'evcc_id_2')))}
                                      />
                                    )}
                                  </td>
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={20} width={100} />
                                    ) : (
                                      <div className="d-flex gap-2">
                                        {isAllowed('evccMap') && (
                                          <Button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => {
                                              setShowEditVehicleForm(true);
                                              setVehicleId(_.get(vehicle, 'id', ''));
                                            }}
                                            style={{ padding: '6px 12px', fontSize: '12px', color: '#fff' }}
                                          >
                                            {t('customerDetail.evccButton')}
                                          </Button>
                                        )}
                                        <Button
                                          className="btn btn-sm btn-primary"
                                          onClick={() => {
                                            setSelectedVehicle(vehicle);
                                            setShowVehicleDetailsModal(true);
                                          }}
                                          style={{ padding: '6px 12px', fontSize: '12px' }}
                                        >
                                          {t('customerProfile.more')}
                                        </Button>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Card>
              )}
              {currentTab === 'bookings' && <CustomerBooking />}
              {currentTab === 'transactions' && <CustomerTransaction />}
              {currentTab === 'preloadedTransactions' && <PreloadedTransaction />}
      {currentTab === 'chargeCoinTransactions' && <ChargeCoinTransaction />}
              {currentTab === 'Faultytransactions' && <CustomerFaultyTransaction />}
              {currentTab === 'paymentStatus' && <PaymentStatus />}
            </div>
          </div>
        </SkeletonTheme>
        {showWalletForm && (
          <Modal show={showWalletForm} size="lg" centered>
            <div className="wallet-transaction_main">
              <Card>
                <div className="wallet-transaction-header__block">
                  <div className="wallet-transaction-name">
                    <span>{t('customerDetail.walletTransaction')}</span>
                  </div>
                  <div className="close-btn">
                    <MdClose size={30} color="#be210b" onClick={handleClose} />
                  </div>
                </div>
                <div className="wallet-transaction_form">
                  <Formik
                    initialValues={{
                      amount: '',
                      user: _.get(customerProfileList, 'id', ''),
                      type: '',
                      message: '',
                    }}
                    validationSchema={WalletTransactionSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      walletTransaction(values);
                      setSubmitting(false);
                    }}
                  >
                    {({ values, errors, touched, setFieldValue, handleSubmit, handleChange, isSubmitting }) => (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col lg={6}>
                            <TextInput
                              isRequired
                              label={t('customerDetail.walletAmount')}
                              type="number"
                              placeholder={t('customerDetail.walletAmount')}
                              name="amount"
                              value={_.get(values, 'amount')}
                              onChange={handleChange}
                              error={errors.amount && touched.amount ? errors.amount : null}
                            />
                          </Col>
                          <Col lg={6}>
                            <Select
                              isRequired
                              label={t('customerDetail.walletType')}
                              options={[
                                { label: 'Credit', value: 'credit' },
                                { label: 'Debit', value: 'debit' },
                              ]}
                              placeholder={t('placeHolder.selectType')}
                              name="type"
                              value={values.type}
                              onChange={(val) => setFieldValue(`type`, val)}
                              error={errors.type && touched.type ? errors.type : null}
                            />
                          </Col>
                          <Col lg={12}>
                            <TextInput
                              isRequired
                              as="textarea"
                              rows="4"
                              inputClass="scrollable"
                              placeholder={t('customerDetail.walletMessage')}
                              label={t('customerDetail.walletMessage')}
                              name="message"
                              value={values.message}
                              onChange={handleChange}
                              error={errors.message && touched.message ? errors.message : null}
                            />
                          </Col>
                        </Row>
                        <div className="wallet-transaction_button">
                          <Button className="wallet-transaction-btn cancel_btn" onClick={handleClose}>
                            {t('button.cancel')}
                          </Button>
                          <Button type="submit" disabled={isSubmitting} className="wallet-transaction-btn create-btn">
                            {t('button.submit')}
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </Card>
            </div>
          </Modal>
        )}
        {showEditForm && (
          <Modal show={showEditForm} size="lg" centered>
            <div className="customer-form-page__main">
              <Card>
                <div className="customer-form-header__block">
                  <div className="customer-header-name">
                    <span>{t('customerDetail.editCustomer')} </span>
                  </div>
                  <div className="close___btn">
                    <MdClose size={30} color="#BE210B" onClick={handleClose} />
                  </div>
                </div>
                <div className="customer-form-body__block">
                  <div className="customer-form--block">
                    <Formik
                      initialValues={{
                        name: '',
                        first_name: _.get(customerProfileList, 'first_name', '') || _.get(customerProfileList, 'name', '').split(' ')[0],
                        last_name:
                          _.get(customerProfileList, 'last_name', '') || _.get(customerProfileList, 'name', '').split(' ').slice(1).join(' '),
                        phone: `+${_.get(customerProfileList, 'country_code')} ${_.get(customerProfileList, 'phone')}`.toString(),
                        email: _.get(customerProfileList, 'email'),
                        generic_otp_allowed: _.get(customerProfileList, 'generic_otp_allowed'),
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        const phoneToSubmit = getPhoneNumber || values.phone;
                        const isPhoneModified =
                          phoneToSubmit !== `+${_.get(customerProfileList, 'country_code')} ${_.get(customerProfileList, 'phone')}`;

                        // Create payload without phone field
                        const { phone, ...restValues } = values;
                        console.log(phone);
                        const payload = {
                          ...restValues,
                          name: values.first_name + ' ' + values.last_name,
                        };

                        // Only include phone-related fields if the phone number has been modified
                        if (isPhoneModified) {
                          const phoneNumber = Number(phoneToSubmit.replace(/\D/g, ''));
                          const countryCode = '91';
                          payload.phone = phoneNumber;
                          payload.country_code = countryCode;
                          payload.old_number = oldPhoneNumber;
                        }

                        updateCustomer(payload);
                        setSubmitting(false);
                      }}
                    >
                      {({ values, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
                        <Form onSubmit={handleSubmit}>
                          <Row>
                            <Col xl={6} lg={12}>
                              <TextInput
                                label={t('customerDetail.editFirstName')}
                                placeholder={t('customerDetail.editFirstName')}
                                name="first_name"
                                value={values.first_name}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xl={6} lg={12}>
                              <TextInput
                                label={t('customerDetail.editLastName')}
                                placeholder={t('customerDetail.editLastName')}
                                name="last_name"
                                value={values.last_name}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xl={6} lg={12}>
                              <PhoneNumberInput
                                label={t('customerDetail.editPhoneNumber')}
                                name="phoneNumber"
                                value={values.phone}
                                onChange={(val) => {
                                  setFieldValue(`phone`, val);
                                  setContactNumber(val || '');
                                  if (!_.isEmpty(phoneError)) {
                                    setPhoneError('');
                                  }
                                }}
                              />
                            </Col>
                            <Col xl={6} lg={12}>
                              <TextInput
                                label={t('customerDetail.editEmail')}
                                placeholder={t('customerDetail.editEmail')}
                                name="email"
                                value={values.email}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xl={6} lg={12}>
                              <CheckBox
                                name="generic_otp_allowed"
                                checked={values.generic_otp_allowed}
                                onChange={(e) => setFieldValue('generic_otp_allowed', e.target.checked)}
                              />
                              <label htmlFor="generic_otp_allowed" className="parking--label">
                                {t('customerDetail.generic_otp_allowed')}
                              </label>
                            </Col>
                          </Row>
                          <div className="form-btn__block">
                            <Button className="form_btn cancel____btn" onClick={handleClose}>
                              {t('button.cancel')}
                            </Button>
                            <Button type="submit" disabled={isSubmitting} className="form_btn">
                              {t('button.edit')}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </Card>
            </div>
          </Modal>
        )}
        {showRoleForm && (
          <Modal show={showRoleForm} size="lg" centered>
            <div className="customer-form-page__main">
              <Card>
                <div className="customer-form-header__block">
                  <div className="customer-header-name">
                    <span>{t('customerDetail.changeRole')} </span>
                  </div>
                  <div className="close___btn">
                    <MdClose size={30} color="#BE210B" onClick={handleClose} />
                  </div>
                </div>
                <div className="customer-form-body__block">
                  <div className="customer-form--block">
                    <Formik
                      initialValues={{
                        username: _.get(customerProfileList, 'username', ''),
                        password: '',
                        role: _.get(customerProfileList, 'role', ''),
                      }}
                      validationSchema={CustomerSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        updateCustomer(values);
                        setSubmitting(false);
                      }}
                    >
                      {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
                        <Form onSubmit={handleSubmit}>
                          <Row>
                            <Col>
                              <Select
                                label={t('customerDetail.role')}
                                placeholder={t('customerDetail.role')}
                                className="customer_roles-select__box"
                                value={_.get(values, 'role', '')}
                                options={_.map(allRoles, (item) => {
                                  return { label: _.startCase(item.name), value: item.name };
                                })}
                                onMenuScrollDown={true}
                                getDataOnScrollDown={getAllRoles}
                                onChange={(val) => setFieldValue(`role`, val)}
                              />
                            </Col>
                            <Col>
                              <TextInput
                                isRequired
                                label={t('customerDetail.userName')}
                                placeholder={t('customerDetail.userName')}
                                name="username"
                                value={values.username}
                                onChange={handleChange}
                                error={errors.username && touched.username ? errors.username : null}
                              />
                            </Col>
                            <TextInput
                              label={t('customerDetail.password')}
                              type="password"
                              name="password"
                              value={values.password}
                              onChange={(e) => setFieldValue('password', e.target.value)}
                            />
                          </Row>
                          <div className="form-btn__block">
                            <Button className="form_btn cancel____btn" onClick={handleClose}>
                              {t('button.cancel')}
                            </Button>
                            <Button type="submit" disabled={isSubmitting} className="form_btn">
                              {t('button.changeRole')}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </Card>
            </div>
          </Modal>
        )}
        {showEditVehicleForm && (
          <Modal show={showEditVehicleForm} size="lg" centered>
            <div className="wallet-transaction_main">
              <Card>
                <div className="wallet-transaction-header__block">
                  <div className="wallet-transaction-name">
                    <span>{t('customerDetail.evccUpdate')}</span>
                  </div>
                  <div className="close-btn">
                    <MdClose size={30} color="#be210b" onClick={handleClose} />
                  </div>
                </div>
                <div className="wallet-transaction_form">
                  <Formik
                    initialValues={
                      vehicleId
                        ? {
                          evcc_id: _.map(currentVehicle, (vehicle) => vehicle && vehicle?.evcc_id).toString(),
                          evcc_id_2: _.map(currentVehicle, (vehicle) => vehicle && vehicle?.evcc_id_2).toString(),
                        }
                        : { evcc_id: '', evcc_id_2: '' }
                    }
                    validationSchema={VehicleSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      editVehicleDetail({
                        ...values,
                        id: vehicleId,
                      });
                      setSubmitting(false);
                    }}
                  >
                    {({ values, errors, touched, handleSubmit, handleChange, dirty }) => (
                      <Form onSubmit={handleSubmit}>
                        <div className="vehicle-form__inner">
                          <Row>
                            <Col lg={12} md={12}>
                              <TextInput
                                label={t('customerDetail.enterEvccId')}
                                placeholder={t('customerDetail.enterEvccId')}
                                name="evcc_id"
                                value={values.evcc_id}
                                onChange={handleChange}
                                error={errors.evcc_id && touched.evcc_id ? errors.evcc_id : null}
                              />
                            </Col>
                            {_.some(currentVehicle, (vehicle) => vehicle?.evcatalog?.is_dual_gun_supported) && (
                              <Col lg={12} md={12}>
                                <TextInput
                                  label={t('customerDetail.enterEvccId2')}
                                  placeholder={t('customerDetail.enterEvccId2')}
                                  name="evcc_id_2"
                                  value={values.evcc_id_2}
                                  onChange={handleChange}
                                />
                              </Col>
                            )}
                          </Row>
                        </div>
                        <div className="vehicle-save--btn--block">
                          <Button type="submit" className="vehicle-save-btn save--btn" disabled={!dirty}>
                            {t('customerDetail.evccButton')}
                          </Button>
                          <Button
                            type="button"
                            className="vehicle-save-btn"
                            style={{ marginLeft: '10px', backgroundColor: '#be210b', border: 'none' }}
                            onClick={() => setShowUnmapConfirm(true)}
                            disabled={!(_.get(currentVehicle[0], 'evcc_id') || _.get(currentVehicle[0], 'evcc_id_2'))}
                          >
                            UnMap EVCC Id
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </Card>
            </div>
          </Modal>
        )}
        {showUnmapConfirm && (
          <Modal show={showUnmapConfirm} onHide={() => setShowUnmapConfirm(false)} centered>
            <div className="wallet-transaction_main">
              <Card>
                <div className="wallet-transaction-header__block">
                  <div className="wallet-transaction-name">
                    <span>UnMap EVCC Id</span>
                  </div>
                  <div className="close-btn">
                    <MdClose size={30} color="#be210b" onClick={() => setShowUnmapConfirm(false)} />
                  </div>
                </div>
                <div className="wallet-transaction_form" style={{ padding: '20px' }}>
                  <p style={{ color: '#fff', fontSize: '16px', marginBottom: '20px' }}>
                    {`this action will unmap ${_.get(currentVehicle[0], 'evcc_id') || _.get(currentVehicle[0], 'evcc_id_2')} evcc_id from ${_.get(
                      customerProfileList,
                      'first_name',
                      ''
                    )} ${_.get(customerProfileList, 'last_name', '')} customer. are you really want to unmap this evcc id?`}
                  </p>
                  <div className="form-btn__block" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button className="form_btn cancel____btn" onClick={() => setShowUnmapConfirm(false)}>
                      No
                    </Button>
                    <Button className="form_btn" onClick={handleUnmap}>
                      Yes
                    </Button>
                  </div>
                </div>
              </Card>
            </div>
          </Modal>
        )}
        {showModal && (
          <Modal show={showModal} centered>
            <RfidDetailsModal onClose={handleClose} />
          </Modal>
        )}
        {showBookingForm && (
          <Modal show={showBookingForm} size="xl" centered>
            <ScheduleBookingForm onClose={handleClose} />
          </Modal>
        )}
        {showVehicleDetailsModal && selectedVehicle && (
          <Modal show={showVehicleDetailsModal} onHide={() => setShowVehicleDetailsModal(false)} centered>
            <Modal.Header style={{ color: '#fff' }}>
              <div className="d-flex justify-content-between align-items-center w-100">
                <Modal.Title style={{ color: '#fff', fontSize: '18px' }}>
                  {_.get(selectedVehicle, 'make', '')} {_.get(selectedVehicle, 'model', '')} - {t('customerDetail.vehicleDetails')}
                </Modal.Title>
                <button
                  onClick={() => setShowVehicleDetailsModal(false)}
                  style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#fff' }}
                >
                  <MdClose />
                </button>
              </div>
            </Modal.Header>
            <Modal.Body style={{ color: '#fff' }}>
              <div className="vehicle-details-content">
                <Row className="mb-3">
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>RTO Registration No</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'rto_no') || _.get(selectedVehicle, 'rto_num') || '-'}</span>
                  </Col>
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>VIN Number</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'vin_num') || '-'}</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>RFID Tag</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'RFID') || '-'}</span>
                  </Col>
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>Year of Manufacture</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'year') || '-'}</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>Vehicle Type</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'type') || '-'}</span>
                  </Col>
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>Ownership Type</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'ownership_type') || '-'}</span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>Max Charging Capacity</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'max_charging_capacity') || '-'}</span>
                  </Col>
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>Total Unit Consumed</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>
                      {_.get(selectedVehicle, 'unit_consumed') !== undefined && _.get(selectedVehicle, 'unit_consumed') !== null
                        ? parseFloat(_.get(selectedVehicle, 'unit_consumed')).toFixed(2) + ' kWh'
                        : 'NA'}
                    </span>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>AutoCharge Supported</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'is_autocharge_supported') ? 'Yes' : 'No'}</span>
                  </Col>
                  <Col xs={6}>
                    <small className="d-block" style={{ color: '#ccc' }}>Dual Gun Supported</small>
                    <span className="fw-medium" style={{ color: '#fff' }}>{_.get(selectedVehicle, 'evcatalog.is_dual_gun_supported') ? 'Yes' : 'No'}</span>
                  </Col>
                </Row>
                {(_.get(selectedVehicle, 'is_autocharge_enabled') === true ||
                  (!_.isEmpty(_.get(selectedVehicle, 'evcc_id')) || !_.isEmpty(_.get(selectedVehicle, 'evcc_id_2')))) && (
                    <>
                      {_.get(selectedVehicle, 'is_autocharge_enabled') === true && _.get(selectedVehicle, 'autocharge_enabled_date') && (
                        <div className="mb-3">
                          <small className="d-block" style={{ color: '#ccc' }}>Auto Charge Enabled Date & Time</small>
                          <span className="fw-medium" style={{ color: '#fff' }}>
                            {moment(_.get(selectedVehicle, 'autocharge_enabled_date')).format('DD/MM/YYYY | HH:mm:ss')}
                          </span>
                        </div>
                      )}
                      {(!_.isEmpty(_.get(selectedVehicle, 'evcc_id')) || !_.isEmpty(_.get(selectedVehicle, 'evcc_id_2'))) &&
                        (_.get(selectedVehicle, 'evccid_save_date') || _.get(selectedVehicle, 'evcc_id_2_save_date')) && (
                          <div className="mb-3">
                            <small className="d-block" style={{ color: '#ccc' }}>EVCC ID Captured Date & Time</small>
                            <div className="fw-medium" style={{ color: '#fff' }}>
                              {_.get(selectedVehicle, 'evccid_save_date') && _.get(selectedVehicle, 'evcc_id_2_save_date') ? (
                                <div>
                                  <div>EVCC ID 1: {moment(_.get(selectedVehicle, 'evccid_save_date')).format('DD/MM/YYYY | HH:mm:ss')}</div>
                                  <div>EVCC ID 2: {moment(_.get(selectedVehicle, 'evcc_id_2_save_date')).format('DD/MM/YYYY | HH:mm:ss')}</div>
                                </div>
                              ) : _.get(selectedVehicle, 'evccid_save_date') ? (
                                moment(_.get(selectedVehicle, 'evccid_save_date')).format('DD/MM/YYYY | HH:mm:ss')
                              ) : (
                                _.get(selectedVehicle, 'evcc_id_2_save_date') &&
                                moment(_.get(selectedVehicle, 'evcc_id_2_save_date')).format('DD/MM/YYYY | HH:mm:ss')
                              )}
                            </div>
                          </div>
                        )}
                    </>
                  )}
              </div>
            </Modal.Body>
          </Modal>
        )}
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>
    </React.Fragment>
  );
};
export default CustomerDetail;
